module.exports = "<gw-locations-and-buildings initial-page=\"renewalBopLocationsAndBuildings\"/>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gw-portals-policytransaction-renewal-bop-angular/locationsAndBuildings/locationsAndBuildings.html
// module id = 880
// module chunks = 0